module.exports = __webpack_public_path__ + "img/img43.4fbda84a.svg";